import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { Icon } from '@material-ui/core';
import useStyles from './styles';

const CustomTimePicker = props => {
  const classes = useStyles();
  const {
    input: { name, value, onChange, ...restInput },
    meta,
    variant,
    warningMessage,
    disabled,
    ...rest
  } = props;
  const serverError = !meta.dirtySinceLastSubmit && meta.submitError;
  const isError = (meta.error || serverError) && meta.touched;

  const isWarning = warningMessage && disabled;
  const errorText = isError && (meta.error || serverError);

  const warningTextComponent = <span className={classes.warningMessage}>{warningMessage}</span>;

  return (
    <KeyboardTimePicker
      className={classes.timePicker}
      {...rest}
      inputVariant={variant}
      name={name}
      helperText={errorText || (isWarning && warningTextComponent) || undefined}
      disabled={disabled}
      error={isError}
      onChange={onChange}
      inputProps={restInput}
      value={value === '' ? null : value}
      keyboardIcon={<Icon>alarm</Icon>}
    />
  );
};

CustomTimePicker.defaultProps = {
  fullWidth: false,
  variant: 'outlined',
  warningMessage: undefined,
  disabled: false,
};

CustomTimePicker.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    onChange: PropTypes.func,
  }).isRequired,
  variant: PropTypes.string,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape().isRequired,
  id: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  warningMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomTimePicker;
